import Header from '../layouts/header/Header'
import heroPhoto from '../pages/Home/assets/Eurowings-ccair.webp'
import { Box } from '@mui/material'

export default function Background({ children }) {
    return (
        <Box
            sx={{
                position: 'relative',
                backgroundImage: `url(${heroPhoto})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                minHeight: '100vh',
                minWidth: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                color: 'white',
            }}
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    zIndex: 1,
                    pointerEvents: 'none',
                }}
            />
            <Box
                sx={{
                    position: 'absolute',
                    zIndex: 3,
                    top: 0,
                    left: 0,
                    right: 0,
                }}
            >
                <Header />
            </Box>
            <Box sx={{ zIndex: 2, width: '100%', pt: { xs: '10vh', sm: '15vh' } }}>
                {children}
            </Box>
        </Box>
    )
}
